import { useCallback } from 'react';
import { trackZoom } from '../../tracking/zoom-tracking';
import type { ZoomSyncedAccount } from '../../type/apps';
import { hasRequiredZoomPermissions } from '../../utils/zoom';
import { zoomServiceType } from '../../utils/zoomServiceType';
import { useZoomOAuth } from './useZoomOAuth';

export function useReconnectZoomAccount() {
  const { disconnectZoomFromOtterAccount, openZoomAuthorizationPage } =
    useZoomOAuth();

  const reconnectZoomAccount = useCallback(
    async (zoomAccounts: ZoomSyncedAccount[]) => {
      if (zoomAccounts.length === 0) {
        return;
      }

      const zoomAccount = zoomAccounts[0];

      if (!hasRequiredZoomPermissions(zoomAccount)) {
        trackZoom.main.reconnectZoomNewScope();
      }

      const featureType = zoomAccount.live_notes_enabled
        ? 'live_notes'
        : 'cloud_sync';

      await Promise.all(
        zoomAccounts.map((zoomAccount) =>
          disconnectZoomFromOtterAccount({ email: zoomAccount.account }),
        ),
      );
      zoomServiceType.set(featureType);
      await openZoomAuthorizationPage();
    },
    [
      disconnectZoomFromOtterAccount,
      openZoomAuthorizationPage,
      zoomServiceType,
    ],
  );

  return {
    reconnectZoomAccount,
  };
}
